import GetSessionLiveState from '@/connection/streams/get-session-live-state';
import { ProjectStateReducerCreator } from '../types';

const loadSessionLiveStateReducer = (create: ProjectStateReducerCreator) => {
  return create.asyncThunk(
    async (sessionUuid: string) => {
      const liveStates = await GetSessionLiveState(sessionUuid);
      const liveEntry = liveStates.find((liveState) => liveState.data.state === 'live');
      return {
        sessionUuid,
        isLive: !!liveEntry,
        liveStartAtMilliSec: liveEntry ? liveEntry.data.timestamp : null,
      };
    },
    {
      pending: (state, action) => {
        if (action.meta.arg !== state.liveSessionUuid) {
          state.isSessionLive = false;
          state.sessionLiveStartAtMilliSec = null;
        }
        state.liveSessionUuid = action.meta.arg;
        state.liveStateRequestId = action.meta.requestId;
      },
      fulfilled: (state, action) => {
        if (action.meta.requestId !== state.liveStateRequestId) return;
        if (action.payload.sessionUuid !== state.liveSessionUuid) return;
        state.isSessionLive = action.payload.isLive;
        state.sessionLiveStartAtMilliSec = action.payload.liveStartAtMilliSec;
      },
      rejected: (state, action) => {
        console.error('Error checking live state:', action.error);
        if (action.meta.requestId !== state.liveStateRequestId) return;
        if (action.meta.arg !== state.liveSessionUuid) return;
        state.isSessionLive = false;
        state.sessionLiveStartAtMilliSec = null;
      },
    }
  );
};

export default loadSessionLiveStateReducer;
